import { useCallback, useMemo, useState } from 'react';
import Button from 'src/components/design-system/Button';
import useBoolean from 'src/hooks/useBoolean';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import { CurrentCompanyOcrGenerateDocPermission } from './errors/useDocumentValidationMessage';

const AbandonOcrButton = () => {
  const { value: deleteModal, setTrue: openDeleteModal, setFalse: closeDeleteModal } = useBoolean();
  const [canDeleteAndMove, setCanDeleteAndMove] = useState<boolean>(false);
  const {
    docNumber,
    ocrPreviewDocument,
    isReviewPanelLoading,
    reviewDocumentValidations,
    selectedSupplier,
    isMergeAttachmentLoading,
    isCreateAndConfirmDocumentLoading,
  } = useInvoiceScanManager();

  const docMatchSupplier = useMemo(
    () =>
      reviewDocumentValidations.matchedSuppliers?.find(
        (s) => s.supplierId === selectedSupplier.supplierId
      ),
    [reviewDocumentValidations.matchedSuppliers, selectedSupplier.supplierId]
  );

  const canMoveAttachment = useMemo(() => {
    const docStatus = reviewDocumentValidations.matchStatus;

    let canMoveAttachment = true;

    if (
      docNumber.value &&
      CurrentCompanyOcrGenerateDocPermission.includes(docStatus) &&
      (!selectedSupplier.supplierId ||
        (selectedSupplier.supplierId && docMatchSupplier && docMatchSupplier.hasOcrDocument))
    ) {
      canMoveAttachment = false;
    } else {
      canMoveAttachment = true;
    }

    return canMoveAttachment;
  }, [
    docMatchSupplier,
    docNumber.value,
    reviewDocumentValidations.matchStatus,
    selectedSupplier.supplierId,
  ]);

  const handleAbandon = useCallback(async () => {
    if (docNumber) {
      setCanDeleteAndMove(canMoveAttachment);
    } else {
      setCanDeleteAndMove(false);
    }
    openDeleteModal();
  }, [canMoveAttachment, docNumber, openDeleteModal]);

  const attachmentIds = ocrPreviewDocument?.attachId ? [ocrPreviewDocument.attachId] : [];

  return (
    <div>
      <Button
        color="error"
        onClick={handleAbandon}
        disabled={
          isReviewPanelLoading || isMergeAttachmentLoading || isCreateAndConfirmDocumentLoading
        }
      >
        Abandon
      </Button>
      <DeleteConfirmationModal
        onClose={closeDeleteModal}
        visible={deleteModal}
        canDeleteAndMove={canDeleteAndMove}
        modalState="review"
        attachmentIds={attachmentIds}
      />
    </div>
  );
};

export default AbandonOcrButton;
